import store from "@/store/index.js";

export default [
  {
    path: "/statistics",
    name: "statistics",
    meta: { requiresAuth: true },
    component: () => import("@/views/Statistics.vue"),
    children: [
      {
        path: "price-to-earning-ratio",
        name: "price-to-earning-ratio",
        meta: { requiresAuth: true },
        component: () =>
          import("@/components/Statistics/PriceToEarningRatio.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchPriceToEarningRatio");
          next();
        }
      },
      {
        path: "income",
        name: "income",
        meta: { requiresAuth: true },
        component: () => import("@/components/Statistics/Income.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchIncome");
          next();
        }
      }
    ]
  }
];
